var map = {
	"./bash": 1750,
	"./java": 1751,
	"./json": 1752,
	"./julia": 1753,
	"./python": 1754,
	"./r": 1755,
	"./rust": 1756,
	"./scala": 1757,
	"./shell": 1758,
	"./sql": 1759,
	"./xml": 1760,
	"./yaml": 1761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1749;